/**
 * Configs houses all of Mission Control's static configurations
 * This includes enumerated lists and maps between line item, ad, and creative types, among others
 */

/**
 * UNRECOGNIZED is used to identify when an API returns a value for which we have no config
 */
export const UNRECOGNIZED = 'UNRECOGNIZED';
/**
 * UNKNOWN_TIMEZONE is the sentinel the backend Timezone enum (campaign-manager / campaign-searcher)
 * serializes when a timezone cannot be mapped (Jackson @JsonEnumDefaultValue _UNKNOWN). It is a
 * non-empty string, so it bypasses truthy guards and must be checked explicitly before being passed
 * to date-fns-tz, which would otherwise log a spurious "timezone is not supported" console error.
 */
export const UNKNOWN_TIMEZONE = '_UNKNOWN';
export const viewerLocalTimeLabel = 'Viewer Local Time';

export * from './types';

// Please keep this alphabetized.
export * from './activeDayTypes';
export * from './adPermittedTemplateTypes';
export * from './adProducts';
export * from './adTypes';
export * from './adTagTypes';
export * from './adTagEvents';
export * from './assetRejectionReasons';
export * from './assetReviewStatuses';
export * from './assetTypes';
export * from './billableThirdParties';
export * from './billingCalendarTypes';
export * from './billingTerms';
export * from './brightline';
export * from './costMethods';
export * from './creativeReviewStatuses';
export * from './creativeTypes';
export * from './deliveryTiers';
export * from './pacingTypes';
export * from './frequencyCapUnitTypes';
export * from './innovid';
export * from './orderOmsLinkTypes';
export * from './orderTypes';
export * from './permittedAdTagEvents';
export * from './permittedAdTypes';
export * from './permittedCreativeTypes';
export * from './priorities';
export * from './reviews';
export * from './statuses';
export * from './utils';
export * from './viewabilityVendors';
export * from './publisher';
export * from './common';
export * from './customPacingRequested';
